import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import * as actions from '../action';
import * as c from '../constant';

function UpdateCalendarEntryModal({
  createInput,
  updateCalendarEntries,
  formData,
  getCalendarEntriesList,
  // history,
  showCalendarEntry,
  setFormData,
  creating,
  calendarEntryData,
}) {
  const setModal = useContext(ModalContext);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const OnSetFormData = () => {
    setFormData({
      title: _.get(calendarEntryData, 'attributes.title') || '',
      date: _.get(calendarEntryData, 'attributes.date'),
      type: _.get(calendarEntryData, 'attributes.type'),
      description: _.get(calendarEntryData, 'attributes.description'),
    });
  };

  useEffect(() => {
    if (!_.isEmpty(calendarEntryData)) {
      OnSetFormData();
    }
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      date: moment(formData.date).format('YYYY-MM-DD'),
    };

    updateCalendarEntries(_.get(calendarEntryData, 'id'), args, ({ data }) => {
      setModal({ isOpen: false });
      getCalendarEntriesList();
      // history.push(`/usermanagement/${_.get(data, 'id')}`);

      showCalendarEntry(data.id);
    });

    // if (!_.isObject(formData.photo)) {
    //   updateCalendarEntries(formData, ({ data }) => {
    //     setModal({ isOpen: false });
    //     getCalendarEntriesList();
    //     // history.push(`/usermanagement/${_.get(data, 'id')}`);
    //     showCalendarEntrie(data.id);
    //   });
    // }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    // getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'title', label: 'Title:' },
              { required: true, placeholder: 'Title' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'description', label: 'Description:' },
              { required: true, placeholder: 'Description' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'type', label: 'Type:' },
              { required: true, placeholder: 'Regular, Special etc.' }
            )}
          </div>
          <div className="form-input-group col-12 col-md-12">
            <label className="form-control-plaintext text-muted">Date:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date')}
              value={moment(_.get(formData, 'date')).format(
                'MM-DD-YYYY'
              )}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateCalendarEntryModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getCalendarEntriesList: PropTypes.instanceOf(Function).isRequired,
  updateCalendarEntries: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  calendarEntryData: PropTypes.instanceOf(Object).isRequired,
  // history: PropTypes.instanceOf(Object).isRequired,
  showCalendarEntry: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_CALENDAR_ENTRIES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateCalendarEntryModal);
